<div class="item">

    <a [target]="openInNewPage ? '_blank' : undefined" [routerLink]="['/case', data.id]">
        <div class="item-link" coreTooltip="Sayfaya Git" (click)="openInNewPage ? (undefined) : closeDialog()" role="button"  tabindex="-1">
            {{data.type === 'case' ? 'V' : 'R'}}
        </div>
    </a>

    <div><b>{{data.id}}</b></div>
    <div>{{data.caseType}}</div>
    <div *ngIf="data.protocolNo">{{data.protocolNo}}</div>
    <div *ngIf="data.date">{{data.date | date: 'dd.MM.yyyy'}}</div>
    <div *ngIf="data.labmedNo">{{data.labmedNo}}</div>
    <div *ngIf="data.provisionNo">{{data.provisionNo}}</div>
    <div class="card-person">
        <i class="fa-solid fa-hospital-user"></i>
        <div *ngIf="data.patientFullName">{{data.patientFullName}}</div>
        <div *ngIf="data.idNumber" coreTooltip="T.C. Kimlik No">{{data.idNumber}}</div>
        <!--
        <div *ngIf="data.phones && data.phones.length > 0">
            <span *ngFor="let phone of data.phones; let isLast = last">
                {{phone}}<span *ngIf="!isLast">, </span>
            </span>
        </div>
        -->
    </div>

    <div class="pin" *ngIf="!pinned">
        <p-button icon="pi pi-star" coreTooltip="Favorilere Ekle" [text]="true" size="small" (onClick)="pinItem()"></p-button>
    </div>
    <div class="pinned" *ngIf="pinned">
        <p-button icon="pi pi-star-fill" coreTooltip="Favorilerden Kaldır" [text]="true" size="small" (onClick)="unpinItem()"></p-button>
    </div>

</div>